__webpack_require__.p = "https://artemis.ritual.co//_next/";